class CommentCardController {
  constructor($sce) {
    'ngInject';

    this.$sce = $sce;
  }

  $onInit() {
    this.sanitizeBody();
  }

  sanitizeBody() {
    this.comment.trustedBody = this.$sce.trustAsHtml(this.comment.body);
  }
}

export default CommentCardController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-msgs/components/comment-card/comment-card.controller.js